import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { EASE } from "../lib/site";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

const clip = {
  hidden: { clipPath: "inset(0% 0% 100% 0%)" },
  show: { clipPath: "inset(0% 0% 0% 0%)", transition: { duration: 1.4, ease: [0.76, 0, 0.24, 1] } },
};

export const ClipImage = ({ src, alt, className = "", frame = "rounded-[2rem]", testid }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);
  return (
    <motion.div ref={ref} className={className} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }}>
      <motion.div variants={clip} className={`relative h-full w-full overflow-hidden ${frame}`}>
        <motion.img style={{ y, scale: 1.18 }} src={src} alt={alt} data-testid={testid} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      </motion.div>
    </motion.div>
  );
};

export const SectionHead = ({ num, eyebrow, title, intro, testid }) => (
  <Reveal className="max-w-3xl" data-testid={testid}>
    <div className="mb-6 flex items-center gap-4">
      <span className="font-display text-sm italic text-[var(--gold-deep)]">{num}</span>
      <span className="h-px w-12 bg-[var(--gold)]" />
      <span className="eyebrow">{eyebrow}</span>
    </div>
    <h2 className="font-display text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">{title}</h2>
    {intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-[var(--ink-soft)] md:text-lg">{intro}</p>}
  </Reveal>
);
